import React, { useEffect, useState } from 'react'
import { Col, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  fishTypeOptions,
  mackerelPackedInOptions,
  packedInOptionsDefault,
  salmonPackedInOptions,
  sardinesPackedInOptions,
  tunaPackedInOptions,
} from './constants'
import Select from 'react-select'
import PropTypes from 'prop-types'

const CannedFishPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    FishType: item.FishType,
    PackedIn: item.PackedIn,
  })
  const [packedInOptions, setPackedInOptions] = useState(packedInOptionsDefault)
  const setPackedInType = () => {
    if (item.FishType === 'Chunk, Light Tuna - 5 oz.') {
      setPackedInOptions(tunaPackedInOptions)
    } else if (item.FishType === 'Mackerel - 15 oz.') {
      setPackedInOptions(mackerelPackedInOptions)
    } else if (
      item.FishType === 'Pink Salmon - 5 oz.' ||
      item.FishType === 'Pink Salmon - 6 oz.' ||
      item.FishType === 'Pink Salmon - 14.75 oz.'
    ) {
      setPackedInOptions(salmonPackedInOptions)
    } else if (item.FishType === 'Sardines - 15 oz.') {
      setPackedInOptions(sardinesPackedInOptions)
    }
  }

  const packedInReset = () => {
    methods.reset(
      { PackedIn: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }
  const methods = useFormContext()
  const { setSelectReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { FishType, PackedIn } = item

      setPackaging({
        FishType,
        PackedIn,
      })

      setPackedInType()
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <h6>Fish Type {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fishTypeOptions}
          defaultValue={{
            label: packaging.FishType,
            value: packaging.FishType,
          }}
          name="FishType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Fish Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setPackedInType()
            packedInReset()
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="FishType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
      <Col xs={6}>
        <h6>Packed in {item?.FishType !== '' ? asterisk : null}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packedInOptions}
          defaultValue={{
            label: packaging.PackedIn,
            value: packaging.PackedIn,
          }}
          name="PackedIn"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Packed In'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PackedIn"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

CannedFishPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default CannedFishPackageReview
